export default __webpack_public_path__ + "9b9b6124dcb45185a0a8bff3505b1f34.png";